@import "../../scss";

.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.close {
  position: fixed;
  bottom: var(--spacer-10);
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;

  @include media-breakpoint-down("md") {
    bottom: var(--spacer-5);
  }
}

.indicators {
  display: flex;
  width: 44rem;
  max-width: 85%;
  position: fixed;
  top: var(--spacer-8);
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;

  @include media-breakpoint-down("md") {
    top: var(--spacer-4);
  }
}

.indicator:not(:last-child) {
  margin-right: 2px;
}

.indicator {
  flex-grow: 1;
  appearance: none;
  border: none;
  outline: none;
  height: 2px;
  background: rgba(#fff, 0.4);
  border-radius: 111px;
  position: relative;
  z-index: 0;
  cursor: pointer;
  transform: translateZ(0);
  overflow: hidden;
  padding: 0;
}

.indicator:before {
  content: "";
  will-change: transform;
  width: 100%;
  height: 500%;
  position: absolute;
  top: -200%;
  left: 0;
  opacity: 0;
}

.indicator-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
}

.indicator-inner:before {
  content: "";
  will-change: transform;
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 111px;
  background: var(--color-bright-green);
  top: 0;
  left: 0;
  transform: translateX(-100%);
}

.indicator--done .indicator-inner:before {
  transform: translateX(0);
}

.indicator--current .indicator-inner:before {
  transform: translateX(-100%);
}

.indicator--current-active .indicator-inner:before {
  transform: translateX(0);
  transition: transform var(--transition-duration) linear;
}

.indicator--upcoming .indicator-inner:before {
  transform: translateX(-100%);
}

.previous {
  position: fixed;
  top: 0;
  left: 0;
  width: 25%;
  height: 100%;
  appearance: none;
  border: none;
  outline: none;
  background-color: transparent;
  cursor: pointer;
}

.next {
  position: fixed;
  top: 0;
  right: 0;
  width: 75%;
  height: 100%;
  appearance: none;
  border: none;
  outline: none;
  background-color: transparent;
  cursor: pointer;
}
